import React from "react";
import { Box, Typography } from "@mui/material";
import { ACCENT, churnCard } from "../churnStyles";

// Shared insight card: full size on the customer Insights tab, `compact`
// in the chat modal's insights sidebar.
const InsightCard = ({ icon: Icon, color, title, headline, detail, action, actionSlot, compact }) => (
  // `compact` cards live in a flex column (chat/insights sidebar): size to
  // content and never shrink, so the suggestion line can't be clipped by the
  // card's overflow:hidden. Full-size cards keep height:100% for equal-height
  // rows on the Insights grid.
  <Box
    sx={{
      ...churnCard,
      p: compact ? 1.5 : 2.25,
      height: compact ? "auto" : "100%",
      flexShrink: 0,
      mb: 0,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
      <Box
        sx={{
          width: compact ? 30 : 40,
          height: compact ? 30 : 40,
          borderRadius: compact ? "9px" : "12px",
          background: `${color}1A`,
          border: `1px solid ${color}26`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon sx={{ color, fontSize: compact ? 16 : 20 }} />
      </Box>
      <Typography
        sx={{
          fontSize: compact ? "11px" : "12px",
          color: "#6B7280",
          fontWeight: 600,
          letterSpacing: "0.6px",
          textTransform: "uppercase",
        }}
      >
        {title}
      </Typography>
    </Box>
    <Typography
      sx={{
        fontSize: compact ? "14px" : "20px",
        color: "#111827",
        fontFamily: "helvetica-lt-std-bold",
        mt: compact ? 1 : 1.5,
        lineHeight: 1.25,
      }}
    >
      {headline}
    </Typography>
    {detail && (
      <Typography sx={{ fontSize: compact ? "12px" : "13px", color: "#6B7280", mt: "6px" }}>
        {detail}
      </Typography>
    )}
    {action && (
      <Typography
        sx={{
          fontSize: compact ? "12px" : "13px",
          color: ACCENT,
          mt: compact ? "6px" : "10px",
          fontWeight: 600,
        }}
      >
        {action}
      </Typography>
    )}
    {actionSlot && <Box sx={{ mt: 1.5 }}>{actionSlot}</Box>}
  </Box>
);

export default InsightCard;
